import styled from "styled-components";
import { TextBold } from "../../Text";
import ChecklistSvg from "core/icons/checklist/checklist-success.svg?react";

export const Container = styled.div`
  display: flex;
  width: 100%;
  border-top: ${({ theme }) => `3px solid ${theme?.colors?.neutral.neutral40}`};
`;

export const StepItem = styled.div<{ active?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding-top: 16px;
  border-top: ${({ theme, active }) =>
    `3px solid ${active ? theme?.colors?.primary.default : theme?.colors?.neutral.neutral40}`};
  margin-top: -3px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const RoundedNumber = styled(TextBold)<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  border: ${({ theme }) => `1px solid ${theme?.colors?.primary.default}`};
  color: ${({ active, theme }) =>
    active ? theme?.colors?.neutral.neutral10 : theme?.colors?.primary.default};
  background-color: ${({ active, theme }) =>
    active ? theme?.colors?.primary.default : theme?.colors?.neutral.neutral10};
`;

export const ChecklistIcon = styled(ChecklistSvg)`
  width: 24px;
  height: 24px;
  padding: 4px;
  border: ${({ theme }) => `1px solid ${theme?.colors?.primary.default}`};
  border-radius: 50%;

  path {
    stroke: ${({ theme }) => theme?.colors?.primary.default};
  }
`;
